import { RouteObject } from "react-router"
import { ViewRootSettings } from "./settings.view"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../data.types"
import { Settings } from "@mui/icons-material"

export enum PathRotaSettings {
    settings = "/configuracoes"
}

const routerSettings: RouteObject = {
    path: PathRotaSettings.settings,
    element: <ViewRootSettings/>,
}


export const navigationToSettingsView = ()=> rotas.navigate(PathRotaSettings.settings)

export function startRouterSettings(){
    const menu:MainMenu = {
        text:"Configurações",
        icon:<Settings />,
        eventOnClick:navigationToSettingsView
    }
    menuRotas.push(menu);
    return routerSettings
}